module.exports = __webpack_public_path__ + "static/media/CRM-notification-sound.417c68d0.mp3";